import { GuestLayout } from '@/layouts/GuestLayout'
import type { GuestProperty } from '@/lib/types'

interface Props {
  property: GuestProperty
}

export default function GuideArchived({ property }: Props) {
  return (
    <GuestLayout propertyName={property.name}>
      <div className="flex flex-1 flex-col items-center justify-center gap-3 px-6 text-center">
        <p className="text-base font-medium">{property.name}</p>
        <p className="text-sm text-muted-foreground">
          The guide for this property is currently unavailable.
        </p>
      </div>
    </GuestLayout>
  )
}
